require('@sentry/browser')
require('@sentry/tracing')
require('angular')
require('angular-animate')
require('angular-dynamic-locale')
require('angular-gettext')
require('angular-sanitize')
require('angular-touch')
require('angular-ui-date')
require('angular-ui-slider')
require('bootstrap/js/src/alert')
require('bootstrap/js/src/collapse')
require('bootstrap/js/src/dropdown')
require('bootstrap/js/src/modal')
require('bootstrap/js/src/popover')
require('bootstrap/js/src/tooltip')
require('core-js/stable')
require('d3')
require('floatthead')
require('i18next')
require('jquery')
require('jquery-datetimepicker/jquery.datetimepicker')
require('jquery-ui-touch-punch')
require('jquery-ui/ui/i18n/datepicker-de')
require('jquery-ui/ui/i18n/datepicker-en-GB')
require('jquery-ui/ui/i18n/datepicker-fr')
require('jquery-ui/ui/i18n/datepicker-it')
require('jquery-ui/ui/widgets/draggable')
require('jquery-ui/ui/widgets/resizable')
require('jquery-ui/ui/widgets/slider')
require('jquery-ui/ui/widgets/sortable')
require('localforage/src/localforage')
require('ol-mapbox-style')
require('ol/Collection')
require('ol/Feature')
require('ol/Geolocation')
require('ol/Map')
require('ol/MapBrowserEvent')
require('ol/Object')
require('ol/Observable')
require('ol/Overlay')
require('ol/View')
require('ol/ViewHint.js')
require('ol/array')
require('ol/color')
require('ol/control/Control')
require('ol/control/MousePosition')
require('ol/control/Rotate')
require('ol/control/ScaleLine')
require('ol/control/Zoom')
require('ol/coordinate')
require('ol/dom')
require('ol/easing')
require('ol/events')
require('ol/events/Event')
require('ol/events/Target')
require('ol/events/condition')
require('ol/extent')
require('ol/format/Feature')
require('ol/format/GML2')
require('ol/format/GML3')
require('ol/format/GPX')
require('ol/format/GeoJSON')
require('ol/format/KML')
require('ol/format/MVT')
require('ol/format/TextFeature')
require('ol/format/WFS')
require('ol/format/WMSCapabilities')
require('ol/format/WMSGetFeatureInfo')
require('ol/format/WMTSCapabilities')
require('ol/format/XML')
require('ol/format/filter')
require('ol/format/filter/Comparison')
require('ol/functions')
require('ol/geom/Circle')
require('ol/geom/Geometry')
require('ol/geom/GeometryCollection')
require('ol/geom/LineString')
require('ol/geom/LinearRing')
require('ol/geom/MultiLineString')
require('ol/geom/MultiPoint')
require('ol/geom/MultiPolygon')
require('ol/geom/Point')
require('ol/geom/Polygon')
require('ol/geom/SimpleGeometry')
require('ol/has')
require('ol/interaction')
require('ol/interaction/DragPan')
require('ol/interaction/Draw')
require('ol/interaction/Interaction')
require('ol/interaction/Modify')
require('ol/interaction/Pointer')
require('ol/interaction/Snap')
require('ol/interaction/Translate')
require('ol/layer/Base')
require('ol/layer/Group')
require('ol/layer/Image')
require('ol/layer/Layer')
require('ol/layer/Tile')
require('ol/layer/Vector')
require('ol/layer/VectorTile')
require('ol/layer/WebGLTile')
require('ol/math')
require('ol/obj')
require('ol/proj')
require('ol/proj/proj4')
require('ol/render.js')
require('ol/render/Event')
require('ol/size')
require('ol/source/Image')
require('ol/source/ImageWMS')
require('ol/source/Tile')
require('ol/source/TileWMS')
require('ol/source/Vector')
require('ol/source/VectorTile')
require('ol/source/WMTS')
require('ol/sphere')
require('ol/string')
require('ol/structs/RBush')
require('ol/style/Circle')
require('ol/style/Fill')
require('ol/style/Icon')
require('ol/style/RegularShape')
require('ol/style/Stroke')
require('ol/style/Style')
require('ol/style/Text')
require('ol/tilegrid')
require('ol/tilegrid/TileGrid')
require('ol/tilegrid/TileGrid.js')
require('ol/tilegrid/WMTS')
require('ol/uri')
require('ol/util')
require('ol/xml')
require('proj4')
require('regenerator-runtime/runtime')
require('resize-observer-polyfill')
require('tinycolor2')
